import angular from 'angular';

angular.module('vrm.core')
    .controller('ResetTwoFactorController', ResetTwoFactorController);

/** @ngInject */
function ResetTwoFactorController($scope, $stateParams, $state, ResetTwoFactorService, LoginService) {
    // Update model with parameters from url
    ResetTwoFactorService.verifyModel.two_factor_reset_hash = $stateParams.two_factor_reset_hash;

    // bind models
    $scope.verifyModel = ResetTwoFactorService.verifyModel;
    $scope.requestModel = ResetTwoFactorService.requestModel;

    // Pre-fill email
    if (LoginService.loginModel.username)
    {
        $scope.requestModel.email = LoginService.loginModel.username;
    }

    /**
     * Flag to hide a submitted form and show a service message
     * @type {boolean}
     */
    $scope.requestReceived = false;

    /**
     * Handle two factor reset request interface logic
     */
    $scope.requestTwoFactorReset = function () {

        if (!$scope.resetTwoFactorForm.$valid) return;

        ResetTwoFactorService
            .resetTwoFactorRequest()
            .then(function (success) {
                if (success) {
                    $scope.requestModel.email = null;
                    $scope.requestReceived = true;
                }
            });
    };

    /**
     * Handle two factor reset verify interface logic
     */
    $scope.verifyTwoFactorReset = function () {

        if (!$scope.verifyTwoFactorResetForm.$valid) return;

        ResetTwoFactorService
            .verifyTwoFactorResetRequest()
            .then(function (success) {
                if (success) {
                    $scope.verifyModel.email = null;
                    $scope.verifyModel.password = null;
                    $scope.verifyModel.two_factor_reset_hash = null;
                    $scope.requestReceived = true;

                    // Logout and login for the cases when the user is already logged in
                    // Clears contexts and user specific data.
                    $scope.$emit('logout');
                    $scope.$emit('login');

                    $state.go('base.profile.twofactor', {}, {location: 'replace'});
                }
            });
    };
}
